/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react"
import { FC } from "react"
import { ButtonProps, Button as _Button, theme } from "antd"
import { buttonCss } from "./styles"
import { IEventDataProps, IPushCoachEventsParams } from "../../../interfaces/api/sms/pushCoachEvents"
import { generateEventAndPush } from "../../../utils/eventUtils"
import { isEmpty } from "lodash"

export interface IButtonProps extends ButtonProps, IEventDataProps {
	pulseAnimation?: boolean
}

const Button: FC<IButtonProps> = (props: IButtonProps) => {
	const { token } = theme.useToken()

	const handleOnClick = (e: any) => {
		if (!isEmpty(props.eventData)) {
			generateEventAndPush(props.eventData)
		}
		props?.onClick?.(e)
	}

	// @ts-ignore
	return <_Button css={buttonCss(token)} {...props} className={props.pulseAnimation ? `${props.className} pulsing-dot` : props.className} onClick={handleOnClick} />
}

export default Button
